import React from 'react';

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 3C5.35051 3 3 5.35051 3 8.25C3 11.1495 5.35051 13.5 8.25 13.5C11.1495 13.5 13.5 11.1495 13.5 8.25C13.5 5.35051 11.1495 3 8.25 3ZM1.5 8.25C1.5 4.52208 4.52208 1.5 8.25 1.5C11.9779 1.5 15 4.52208 15 8.25C15 11.9779 11.9779 15 8.25 15C4.52208 15 1.5 11.9779 1.5 8.25Z"
      fill="var(--color-brand-900)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9947 11.9947C12.2876 11.7018 12.7624 11.7018 13.0553 11.9947L16.2803 15.2197C16.5732 15.5126 16.5732 15.9874 16.2803 16.2803C15.9874 16.5732 15.5126 16.5732 15.2197 16.2803L11.9947 13.0553C11.7018 12.7624 11.7018 12.2876 11.9947 11.9947Z"
      fill="var(--color-brand-900)"
    />
  </svg>
);
